export const CONSTANTS = {
  RADIUS: 0.00375,
};
